class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const end = this.dataset.end;
    if (!end) {
      this.querySelector('[data-countdown-timer]')?.setAttribute('hidden', '');
      const label = this.querySelector('[data-countdown-label]');
      if (label) label.hidden = true;
      return;
    }
    this.endTime = new Date(end).getTime();
    if (Number.isNaN(this.endTime)) {
      this.querySelector('[data-countdown-timer]')?.setAttribute('hidden', '');
      return;
    }

    this.days = this.querySelector('[data-countdown-days]');
    this.hours = this.querySelector('[data-countdown-hours]');
    this.minutes = this.querySelector('[data-countdown-minutes]');
    this.seconds = this.querySelector('[data-countdown-seconds]');

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = this.endTime - Date.now();
    if (remaining <= 0) {
      clearInterval(this.interval);
      this.querySelector('[data-countdown-timer]').hidden = true;
      const label = this.querySelector('[data-countdown-label]');
      if (label) label.textContent = window.themeStrings?.countdownEnded || '';
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (this.days) this.days.textContent = String(days).padStart(2, '0');
    if (this.hours) this.hours.textContent = String(hours).padStart(2, '0');
    if (this.minutes) this.minutes.textContent = String(minutes).padStart(2, '0');
    if (this.seconds) this.seconds.textContent = String(seconds).padStart(2, '0');
  }
}

customElements.define('countdown-timer', CountdownTimer);
